import { MapTo } from '@adobe/aem-react-editable-components';
import React, { useEffect } from 'react';
import ProfileContainer from './ProfileContainer';
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import {getPlansData, setSelectedPlanNumber} from "../../redux/profile/slice";
import {
  getCurrentScreen,
  getIsPlansDataLoaded,
  getReceivedPlansData, getSelectedPlan
} from "../../redux/profile/selectors";
import Loading from "../Shared/Loading";

const ProfileContainerEditConfig = {
  emptyLabel: 'Profile Container',

  isEmpty: function(props) {
    return !props;
  },
};

const ProfileContainerWrapper = () => {
  const dispatch = UseAppDispatch();
  const isPlansDataLoaded =UseAppSelector(getIsPlansDataLoaded);
  const planData = UseAppSelector(getReceivedPlansData);
  const selectedPlan = UseAppSelector(getSelectedPlan);
  const planNumber = selectedPlan.value;

  useEffect(() => {
    if(!isPlansDataLoaded) {
      dispatch(getPlansData());
    }

  }, []);

  if(!isPlansDataLoaded){
    return <Loading topMargin="20% auto 20%" />
  }


  return (
      <>
        {isPlansDataLoaded && planData && planData.length && planNumber && <ProfileContainer/>}
      </>
  )

}

export default MapTo('workplace-profile/components/profilecontainer')(
    ProfileContainerWrapper,
    ProfileContainerEditConfig,
);
